<template>
  <a
    class="invite_members"
    data-testid="viewer-invite-team-member"
    :href="link"
    :title="title"
    v-bind:class="{ active: hovered }"
    v-b-tooltip.hover.right
    @mouseover="setHovered(true)"
    @mouseleave="setHovered(false)"
    @click="trackEvent"
  >
    <img
      class="invite_default"
      :src="hovered ? InviteActiveImage : InviteDefaultImage"
    />
  </a>
</template>

<script>
import InviteDefaultImage from "../../images/icons-invite-default.svg";
import InviteActiveImage from "../../images/icons-invite-active.svg";
import track from "../tracking";

export default {
  data: function () {
    return {
      InviteDefaultImage,
      InviteActiveImage,
      hovered: false,
    };
  },
  props: {
    isPersonal: { type: Boolean },
  },
  methods: {
    setHovered: function (value) {
      this.hovered = value;
    },
    trackEvent: function () {
      if (!this.isPersonal) {
        track("viewer_clicked_menu_item", {
          url: this.$route.fullPath,
          action: "invite_to_team",
          where: "invite_member_button",
        });
      }
    },
  },
  computed: {
    link: function () {
      if (this.isPersonal) {
        return "/purchase?period=annual&plan=team&trial=true&utm_campaign=viewer_create_team&utm_source=viewer";
      }

      return "#invite";
    },
    title: function () {
      if (this.isPersonal) {
        return "Create a team";
      }

      return "Invite team member";
    },
  },
};
</script>

<style scoped lang="scss">
@import "application.scss";

.invite_members {
  display: block;
  width: 2.5rem;
  height: 2.5rem;
  margin: auto;
  border: 1px solid #dedede;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;

  &.active {
    border-color: #007aff;
    cursor: pointer;
  }

  .invite_default {
    pointer-events: none;
  }
}
</style>
